import uuid from "uuid";

export function getAccessToken() {
  let accessToken = null;

  if (!!localStorage.getItem("persist:auth")) {
    const persist = JSON.parse(localStorage.getItem("persist:auth"));
    if (!!persist.auth) {
      const auth = JSON.parse(persist.auth);
      if (!!auth.accessToken) {
        accessToken = auth.accessToken;
      }
    }
  }

  return accessToken;
}

export function getAuth() {
  let auth = null;

  if (!!localStorage.getItem("persist:auth")) {
    const persist = JSON.parse(localStorage.getItem("persist:auth"));
    if (!!persist.auth) {
      auth = JSON.parse(persist.auth);
    }
  }

  return auth;
}


export function getSessionId() {
  const sessionId = !!localStorage.getItem("sessionId") ? localStorage.getItem("sessionId") : uuid.v4();
  setSessionId(sessionId);
  return sessionId;
}

export function setSessionId(sessionId) {
  localStorage.setItem("sessionId", sessionId);
}